<div class="careers">
    <app-new-header></app-new-header>

    <div class="section_one" style="background-image: url('../../../../assets/img/dotted-map.jpg')">
        <div class="overlay">
            <div class="left">
                <div>CAREERS</div>
                <h3>Ready to join our team?</h3>
    
                <div class="buttons">
                    <button (click)="scrollToOpenRoles()">Explore open roles</button>
                </div>
            </div>
            <div class="right">
                <img src="../../../../assets/img/careers.svg" alt="">
            </div>
        </div>
    </div>

    <div class="section_divider">
        <img src="../../../../assets/img/spiralone.png" alt="" class="spiral">
    </div>


    <div style="margin-top: 10px;"></div>
    <div class="section_four">
        <div class="top rev">
            <div class="cell">
                <h3 class="why">HuiosPay goes for nothing but the best</h3>
                <div class="subtext">
                    We are equipped to create a work community that pushes everyone to believe in themselves and become go-getters. From
                    interns to experts, from raw-talented individuals to skilled-talented individuals, all are welcome to HuiosPay.
                </div>
                
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/section4one.jpg" alt="">
            </div>
        </div>
        <div class="top bottom">
            <div class="cell">
                <h3 class="why">We are One</h3>
                <div class="subtext">We think as one, work as one, share as one, play as one and win as one. Your goals are our goals, your dreams are our
                dreams, and HuiosPays vision is our vision.</div>
    
    
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/womaninoffice.jpg" alt="">
            </div>
        </div>
    </div>
    
    
    <div class="section_four">
        <div class="top rev">
            <div class="cell">
                <h3 class="why">It's all love and respect for one another</h3>
                <div class="subtext">Love thy neighbor as thy self", one of our prime rule and view towards our colleagues. We believe in work fluidity and
                flexibility due the massive love and respect everyone gives to everyone. It's our culture.</div>
    
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/section4one.jpg" alt="">
            </div>
        </div>
        
    </div>
    
    <div id="open-roles" class="open-roles" style="background-image: url('../../../../assets/img/section5bg.png');">
        <h3>No Open roles</h3>
        <p>There is no current open spot. Once there is a post, it will be posted here.</p>
    </div>

    <div class="section_seven" style="background-image: url('../../../../assets/img/section7.jpg');">
        <div class="join">
            <h3>Join the community of smart business decision makers</h3>
    
    
    
            <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16" target="_blank">
                <button>Open a Merchant Account</button>
            </a>
        </div>
    </div>
    
    <app-new-footer></app-new-footer>
    
</div>